module.exports = __webpack_public_path__ + "0f5df1ba95d6aeae500882ca40d6e98b.png";